var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup298(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.896,
    height: 14.832,
    viewBox: "0 0 19.896 14.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-283.344 -29.084)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 17.895,
    transform: "translate(284.344 30.084)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 10.396,
    transform: "translate(291.843 36.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 17.895,
    transform: "translate(284.344 42.916)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup298);
export default __webpack_public_path__ + "static/media/Group 298.cd15f4ac8934434c50d26d093959b2a8.svg";
export { ForwardRef as ReactComponent };